"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_UINT = exports.PricingMethod = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
var paraswap_core_1 = require("paraswap-core");
Object.defineProperty(exports, "ContractMethod", { enumerable: true, get: function () { return paraswap_core_1.ContractMethod; } });
Object.defineProperty(exports, "SwapSide", { enumerable: true, get: function () { return paraswap_core_1.SwapSide; } });
// TODO: This is legacy and can be removed
var PricingMethod;
(function (PricingMethod) {
    PricingMethod["megapath"] = "megapath";
    PricingMethod["multipath"] = "multipath";
    PricingMethod["simplepath"] = "simplepath";
})(PricingMethod = exports.PricingMethod || (exports.PricingMethod = {}));
exports.MAX_UINT = new bignumber_js_1.default(2).pow(256).minus(1);
//# sourceMappingURL=constants.js.map